import { render } from "./Pictures.vue?vue&type=template&id=4018fb8e&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"

import "./Pictures.vue?vue&type=style&index=0&id=4018fb8e&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\CasaPortugal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4018fb8e"]])

export default __exports__